import React from "react";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "@/store";
import JBApp from "@/JBApp";

Sentry.init({
  dsn: "https://70ea814255c91a470e449505ce0ee39d@logs.g-r-l.com/27",
  environment: import.meta.env.MODE,
  release: "jb@1.0.0",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Failed to find the root element");
}
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <JBApp />
    </Provider>
  </React.StrictMode>,
);
